import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { PoolAssignmentDropdown } from '~src/settings/bridge-settings/sections/bridgeNetworkAllowlist/addNewDomainDialog/PoolAssignmentDropdown';
import { PoolAssignmentOption } from '~src/settings/bridge-settings/sections/types/PoolAssignmentOption';
import { PoolID, SystemDefinedPoolID } from '~src/settings/bridge-settings/sections/types/PoolID';
import { IRemoteQueryAgent } from '~src/settings/types/ISiteAdminBridgeSettings';

export type PropsForEditRemoteAgentPoolDialog = ReactActionDialogBodyProps<
  EditRemoteAgentPoolDialogProps,
  EditRemoteAgentPoolDialogState
>;

export type EditRemoteAgentPoolDialogProps = Readonly<{
  agent: IRemoteQueryAgent;
  poolOptions: ReadonlyArray<PoolAssignmentOption>;
}>

export type EditRemoteAgentPoolDialogState = Readonly<{
  selectedPoolId?: PoolID;
}>

export function EditRemoteAgentPoolDialogBody(props: PropsForEditRemoteAgentPoolDialog) {
  const legacyPoolList: ListItem[] = !FeatureFlags.edgeMultiPoolEnabled ? createLegacyPoolList() : null;
  const dialogPrompt = Messages.editRemoteAgentPoolDialogPrompt({ AGENT_NAME: L10n.elideIfLong(props.agent.agentName) });
  const onPoolDropdownChange = (id: PoolID) => props.updateDialogState({ selectedPoolId: id });

  return <>
    <span>{dialogPrompt}</span>
    <div style={{ marginTop: 18, marginBottom: 30 }}>
      {FeatureFlags.edgeMultiPoolEnabled ?
        <PoolAssignmentDropdown
          onPoolAssignmentChange={onPoolDropdownChange}
          assignedPoolID={props.dialogState.selectedPoolId}
          poolOptions={props.poolOptions}
        />
        :
        <SingleSelectDropdown
          children={props.dialogState.selectedPoolId ? null : Messages.bridgeSiteSettingsPoolDropdownPlaceholder()}
          list={<List items={legacyPoolList} />}
          type={DropdownButtonType.Outline}
          value={props.dialogState.selectedPoolId}
          onChange={onPoolDropdownChange}
          label={Messages.siteRemoteAgentPoolColumnName()}
          testId={'agent-edit-pool-dropdown'}
        />
      }
    </div>
  </>;
}

function createLegacyPoolList() {
  const pooledListItem: ListItem = {
    content: Messages.siteRemoteAgentPoolNameDefault(),
    value: SystemDefinedPoolID.Default
  };
  const notPooledListItem: ListItem = {
    content: Messages.siteRemoteAgentPoolNameNotAvailable(),
    value: SystemDefinedPoolID.Unassigned
  };
  return [pooledListItem, notPooledListItem];
}
